var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isShow ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.formLabel
    }
  }, [_vm.setting && _vm.setting.type == 'input' ? _c('div', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.isError ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.setting && _vm.setting.type == 'select' ? _c('div', [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "state": _vm.isError ? false : null,
      "options": _vm.options,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _c('div', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.isError ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1), _vm.isError ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }